// extracted by mini-css-extract-plugin
export default {"edit":"EditDocument_edit__1hF6i","close":"EditDocument_close__BWk1f","picked_categories":"EditDocument_picked_categories__-dTjO","employees":"EditDocument_employees__RM4IJ"};